import { canBlend, type Scene } from '@flobi/artwork-core';

/** Top-level, unlocked endpoints on one artboard, ordered as they are painted. */
export function blendSelection(scene: Scene, selection: readonly string[]): string[] {
  const selected = new Set(selection);
  if (selected.size < 2) return [];
  const ids = scene.paintOrder().filter(id => selected.has(id));
  if (ids.length !== selected.size || ids.some(id => scene.lockedHere(id) || !canBlend(scene, id)
    || scene.get(id)?.type === 'blend' || Array.from(scene.ancestors(id)).some(parent => selected.has(parent) || scene.get(parent)?.type === 'blend'))) return [];
  const boardOf = (id: string) => Array.from(scene.ancestors(id)).find(parent => scene.get(parent)?.type === 'artboard') ?? null;
  return ids.every(id => boardOf(id) === boardOf(ids[0]!)) ? ids : [];
}
